import React from 'react'
import { Typography, message } from 'antd'
import { Redirect, useHistory } from 'react-router-dom'
import * as yup from 'yup'
import { MailOutlined, LockOutlined } from '@ant-design/icons'

import { useAuth } from '@contexts/AuthContext'
import { Form, TextInput, SubmitButton } from '@components/Form'
import { useLocalization } from '@contexts/LocalizationContext'

const Login = () => {
  const { login, user } = useAuth()
  const history = useHistory()
  const { t } = useLocalization()

  const validationSchema = yup.object().shape({
    email: yup
      .string()
      .required(t('loginScreen.error.emailRequired'))
      .email(t('loginScreen.error.emailInvalid')),
    password: yup.string().required(t('loginScreen.error.passwordRequired')),
  })

  const handleSubmit = async (formData) => {
    try {
      await login(formData)
      history.push('/dashboard')
      message.success(t('loginScreen.message.success'))
    } catch (e) {
      message.error(t('loginScreen.message.failed'))
    }
  }

  if (user) {
    return <Redirect to="/dashboard" />
  }

  return (
    <Form onSubmit={handleSubmit} validationSchema={validationSchema}>
      <Typography.Title>{t('loginScreen.title')}</Typography.Title>
      <TextInput
        label=""
        formItemOptions={{ formItemLayout: null }}
        prefix={<MailOutlined />}
        name="email"
        placeholder={t('loginScreen.email')}
      />
      <TextInput
        label=""
        formItemOptions={{ formItemLayout: null }}
        prefix={<LockOutlined />}
        name="password"
        placeholder={t('loginScreen.password')}
        type="password"
      />
      <SubmitButton
        formItemOptions={{ formItemLayout: null }}
        label=""
        block
        type="primary"
      >
        {t('loginScreen.button')}
      </SubmitButton>
      {/* <div style={{ textAlign: 'right' }}>
        <Link to="/forgotPassword">{t('loginScreen.forgotPassword')}</Link>
      </div> */}
    </Form>
  )
}

export default Login
